const eDeliveryInlineViewTemplate = `
<div>
    <h3 class="margin-top-0">{{ 'summary.eDelivery.title' | translate }}</h3>

    <form name="eConsentForm" autocomplete="off" novalidate >
        <div class="details-section">
            <div class="inline-communication-preferences">
                <div>
                    <p>{{ 'summary.eDelivery.getEdelivery' | translate }}</p>
                    
                    <ul class="margin-left-200 margin-bottom-100">
                        <li>{{ 'summary.eDelivery.benefits.one' | translate }}</li>
                        <li>{{ 'summary.eDelivery.benefits.two' | translate }}</li>
                        <li>{{ 'summary.eDelivery.benefits.three' | translate }}</li>
                        <li>{{ 'summary.eDelivery.benefits.four' | translate }}</li>
                    </ul>
                </div>

                <div class="checkbox-inline">
                    <label for="communicationPreference">
                        <input type="checkbox"
                               name="communicationPreference"
                               id="communicationPreference"
                               ng-model="ctrl.communicationPreference"
                               ng-true-value="'{{ctrl.CommunicationPreference.EDELIVERY_ONLY}}'"
                               ng-false-value="'{{ctrl.CommunicationPreference.EDELIVERY_AND_MAIL}}'"
                               ng-change="ctrl.onChangeEDelivery()">
                        {{ 'summary.eDelivery.labelEDeliveryOnly' | translate }}
                    </label>
                    
                    <p ng-if="ctrl.showDocTypes()">{{ 'summary.eDelivery.documentsInclude' | translate:ctrl.getDocTypes() }}</p>
                    <!--list of emails-->
                    <div class="form-group" ng-if="ctrl.showEmailDropdown()">
                        <div class="col-xs-12">
                            <label for="emailChoice">{{ 'preference.eDelivery.label.email' | translate }}</label>
                            <select class="form-control"
                                    id="emailChoice"
                                    name="emailChoice"
                                    ng-model="ctrl.emailChoice"
                                    ng-change="ctrl.onChangeEmail()">
                                <option ng-repeat="email in ctrl.getEmailChoices()" value="{{email}}">{{email}}</option>
                            </select>
                        </div>
                    </div>

                    <!-- no email-->

                    <div class="form-group"
                         ng-class="ctrl.getFormGroupClass('emailChoice')"
                         ng-if="ctrl.showEmailInput()">
                      <label for="personalEmailInput"
                             class="control-label">{{ "profile.personal.emailAddress" | translate }}</label>
                      <input type="text"
                             name="emailChoice"
                             id="personalEmailInput"
                             class="form-control"
                             data-ng-model="ctrl.emailChoice"
                             data-ng-required="ctrl.isEmailRequired()"
                             ng-change="ctrl.onChangeEmail()"
                             maxlength="80"
                             pw-email />

                      <ng-messages for="ctrl.getFieldError('emailChoice')" data-ng-if="ctrl.isDirty('emailChoice')">
                          <ng-message when="required">{{ "preference.eDelivery.errorEmailRequired" | translate }}</ng-message>
                          <ng-message when="emailFormat">{{ "preference.eDelivery.errorEmailInvalid" | translate }}</ng-message>
                      </ng-messages>
                    </div>
                    
                    <div class="document-review">
                        <p ng-bind-html="'preference.eDelivery.legal.section' | translate"></p>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>
`;
export default eDeliveryInlineViewTemplate;
